import { render, staticRenderFns } from "./QueryXDList.vue?vue&type=template&id=5d7a9fdc&scoped=true"
import script from "./QueryXDList.vue?vue&type=script&lang=js"
export * from "./QueryXDList.vue?vue&type=script&lang=js"
import style0 from "./QueryXDList.vue?vue&type=style&index=0&id=5d7a9fdc&prod&scoped=true&lang=stylus&rel=stylesheet%2Fstylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7a9fdc",
  null
  
)

export default component.exports